/**
 * Zentrale Passwort-Regel für das Frontend ("Länge-zuerst", BSI/DSGVO-konform).
 *
 * Ein Passwort ist gültig, wenn:
 *  1. es mindestens 12 Zeichen hat (egal welche Zeichen), ODER
 *  2. es mindestens 8 Zeichen hat UND einen Groß- und einen Kleinbuchstaben
 *     UND eine Zahl ODER ein Sonderzeichen enthält.
 *
 * "Sonderzeichen" = jedes Zeichen, das nicht A-Z, a-z oder 0-9 ist (inkl. Bindestrich).
 * Damit werden Passwort-Manager-Passwörter (Apple-Schlüsselbund, Google) und
 * Passphrasen akzeptiert.
 */

export const PASSWORD_MAX_LENGTH = 128;

/**
 * Liefert die einzelnen Kriterien-Booleans für die Live-Haken-Anzeige.
 * @param {string} password
 * @param {string} [confirmPassword]
 * @returns {{ length12: boolean, min8: boolean, letters: boolean, numberOrSpecial: boolean, match: boolean }}
 */
export const getPasswordChecks = (password = '', confirmPassword = '') => ({
  length12: password.length >= 12,
  min8: password.length >= 8 && password.length <= PASSWORD_MAX_LENGTH,
  letters: /[a-z]/.test(password) && /[A-Z]/.test(password),
  numberOrSpecial: /[0-9]/.test(password) || /[^A-Za-z0-9]/.test(password),
  match: password === confirmPassword && confirmPassword.length > 0,
});

/**
 * Prüft, ob ein Passwort gültig ist (ohne Bestätigungsabgleich).
 * @param {string} password
 * @returns {boolean}
 */
export const isPasswordValid = (password = '') => {
  if (password.length > PASSWORD_MAX_LENGTH) return false;
  const { length12, min8, letters, numberOrSpecial } = getPasswordChecks(password);
  return length12 || (min8 && letters && numberOrSpecial);
};

// Fehlermeldung passend zur Regel (für Submit-Validierung)
export const PASSWORD_RULE_MESSAGE =
  'Bitte nutze mindestens 12 Zeichen – oder mindestens 8 Zeichen mit Groß- und ' +
  'Kleinbuchstaben sowie einer Zahl oder einem Sonderzeichen';
